import { Box } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import { GlobeIcon } from 'assets/icons'
import PopupSectionRow from 'components/popup/PopupSectionRow'
import { useAppSettings } from 'components/providers/AppSettingsProvider'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import TimezonePopup from '../eventInfo/TimezonePopup'

export default function FallbackTimezoneSetting() {
  const [open, setOpen] = useState(false)
  const theme = useTheme()
  const { t } = useTranslation()
  const settings = useAppSettings()

  return (
    <TimezonePopup
      open={open}
      setOpen={setOpen}
      setTimeZone={settings.setTimeZone}
    >
      <span
        id="fallback-timezone-button"
        role="button"
        tabIndex={0}
        aria-label={`${t('timeZone')}: ${settings.timeZone}`}
        aria-expanded={open}
        onClick={() => setOpen((wasOpen) => !wasOpen)}
        onKeyDown={(event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault()
            setOpen((wasOpen) => !wasOpen)
          }
        }}
      >
        <PopupSectionRow
          title={t('timeZone')}
          icon={<GlobeIcon />}
          iconClass="icon-regular"
          maxWidthIcon={20}
          cursor="pointer"
          actionBg
          engulfEntireRow
          value={
            <Box
              component="span"
              title={settings.timeZone}
              sx={{
                display: 'block',
                maxWidth: '180px',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap'
              }}
            >
              {settings.timeZone}
            </Box>
          }
          valueColor={theme.palette.text.disabled}
        />
      </span>
    </TimezonePopup>
  )
}
